import type { Utility } from '../../../types/utility';
import type { Cards } from './index';
import colors from '../../colors';

const baseVariantShared: Utility.CSSProperties = {
  width: '100%',
  padding: '24px',
};

const base = {
  default: {
    ...baseVariantShared,
  },
  large: {
    ...baseVariantShared,
    '[data-card-element="heading"]': {
      order: -1,
    },
    '[data-card-element="divider"]': {
      display: 'none',
    },
  },
  gradient: {
    ...baseVariantShared,
    maxWidth: '360px',
    padding: '40px 32px',
    border: 'none',
    boxShadow: 'none',
    background: `linear-gradient(180deg, ${colors.white} 0%, ${colors.coolGrey[5]} 100%)`,
  },
};

const resourceCard: Utility.VariantKeyModes<Cards.ResourceCard.VariantKeys> = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base,
  },
};

export const resourceCardVariants = Object.keys(base) as Cards.ResourceCard.VariantKeys[];

export default resourceCard;
